import React from 'react';
import { ColumnDefinition } from '../../models';
import {
  dateColumn,
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATETIME_FORMAT,
  DEFAULT_TIME_FORMAT,
} from './dateColumn';
import { numberColumn } from './numberColumn';

const DATE_DEFAULT_FORMATS: Record<string, string> = {
  date: DEFAULT_DATE_FORMAT,
  datetime: DEFAULT_DATETIME_FORMAT,
  time: DEFAULT_TIME_FORMAT,
};

export const processColumns = (
  columns: ColumnDefinition[]
): ColumnDefinition[] => {
  return columns
    .map((column: ColumnDefinition) => {
      if (column.format && DATE_DEFAULT_FORMATS[column.format.type]) {
        const defaultFormat = DATE_DEFAULT_FORMATS[column.format.type];

        return {
          ...column,
          render: (value: any) => (
            <span>
              {dateColumn(value, column.format.format, defaultFormat)}
            </span>
          ),
        };
      } else if (column.format && column.format.type === 'number') {
        return {
          ...column,
          render: (value: any) => (
            <span>{numberColumn(value, column.format.format)}</span>
          ),
        };
      }
      return {
        ...column,
        render: (value: any) => (
          <>{String(value).includes('null') ? undefined : value}</>
        ),
      };
    })
    .sort((a, b) => {
      const orderA = a.order ?? Number.MAX_SAFE_INTEGER;
      const orderB = b.order ?? Number.MAX_SAFE_INTEGER;

      return orderA - orderB;
    });
};
